import {
	Box,
	Button,
	Card,
	CardContent,
	CardHeader,
	Divider,
	Grid,
	LinearProgress, makeStyles
} from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { useActions, useValues } from 'kea';
import profilelogic from 'src/store/profile';

//TODO clean style
const useStyles = makeStyles(() => ({
	root: {}
}));

const Preferances = ({ className, ...rest }) => {
	const classes = useStyles();
	const { profile } = useValues(profilelogic);
	const { update } = useActions(profilelogic);
	const [values, setValues] = useState(profile.preferences);


	const handleChange = (event) => {
		let newValues = { ...values };
		newValues = {
			...newValues,
			[event.target.name]: event.target.checked
		}
		setValues(newValues);
	};

	const handleUpdate = () => update({
		preferences: values
	});

	return (
		<form
			autoComplete="off"
			noValidate
			className={clsx(classes.root, className)}
			{...rest}
		>
			<Card>
				<CardHeader
					subheader="Set your preferences for notifications here."
					title="Notification Preferences"
				/>
				<Divider style={{ marginBottom: '10px' }} />
				<CardContent>
					<Grid
						container
						spacing={3}
					>
						<Grid
							item
							md={4}
							xs={12}
						>
							<FormControlLabel
								control={
									<Switch
										checked={values.instant_email}
										onChange={handleChange}
										name="instant_email"
										color="primary"
									/>
								}
								label="Instant Email"
							/>
						</Grid>
						<Grid
							item
							md={4}
							xs={12}
						>
							<FormControlLabel
								control={
									<Switch
										checked={values.daily_email}
										onChange={handleChange}
										name="daily_email"
										color="primary"
									/>
								}
								label="Daily Email"
							/>
						</Grid>
						{/* <Grid
							item
							md={4}
							xs={12}
						>
							<FormControlLabel
								control={
									<Switch
										checked={values.sms}
										onChange={handleChange}
										name="sms"
										color="primary"
									/>
								}
								label="SMS"
							/>
						</Grid> */}
						{/* <Grid
							item
							md={3}
							xs={12}
						>
							<TextField
								id="standard-select-timezone"
								select
								label="Timezone"
								name="timezone"
								value={values.preferences.timezone}
								onChange={handleChange}
								helperText="Preferred Timezone"
							>
								{[
									'AWST',
									'ACWST',
									'ACST',
									'AEST',
									'ACDT',
									'AEDT'
								].map((option) => (
									<MenuItem key={option} value={option}>
										{option}
									</MenuItem>
								))}
							</TextField>
						</Grid> */}
					</Grid>
				</CardContent>
				<Divider style={{ marginTop: '10px' }} />
				<Box
					display="flex"
					justifyContent="flex-end"
					p={2}
				>
					<Button
						color="primary"
						variant="outlined"
						onClick={handleUpdate}
					>
						Save
					</Button>
				</Box>
			</Card>
		</form>
	);
};

Preferances.propTypes = {
	className: PropTypes.string
};

export default Preferances;
